import { render, staticRenderFns } from "./AutoDesformDataModal.vue?vue&type=template&id=28fa4e58&scoped=true&"
import script from "./AutoDesformDataModal.vue?vue&type=script&lang=js&"
export * from "./AutoDesformDataModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28fa4e58",
  null
  
)

export default component.exports